/*
    Common custom string manipulating codes/functions can be writter here

*/
import axios from "axios";
import { travelOnlineLeadsStructure } from "../configs/configs";

export class apiCalls {
  static logFile(fs, data, filename) {
    const logFilePath = filename;
    fs.writeFile(logFilePath, data, (err) => {
      if (err) {
        console.error("Error writing to log file:", err);
      } else {
        console.log("Object logged to:", logFilePath);
      }
    });
  }
  static async getTravelServicesData(quoteID) {
    const payload = {
      quoteId: quoteID,
    };

    const payloadString = JSON.stringify(payload);
    //console.log("payloadString", quoteID)
    try {
      const response = await fetch("/api/TravelServices/getInitData", {
        method: "POST",
        body: payloadString,
      });
      const result = await response.json();

      return { status: true, data: result };
    } catch (e) {
      //console.log("error kyc", e)
      return { status: false };
    }
  }

  static async getTravelServicesPaymentLink(payload) {
    //payload['isPrepaid']=true
    const payloadString = JSON.stringify(payload);
    //console.log("payload", payloadString)
    try {
      const response = await fetch("/api/TravelServices/pushData", {
        method: "POST",
        body: payloadString,
      });
      let result;
      if (payload.pmlClicked === "true") {
        result = await response.json();
      } else {
        result = await response.json();
      }
      //console.log("result", result)
      return { status: true, data: result };
    } catch (e) {
      //console.log("error pushing data to server", e)
      return { status: false };
    }
  }

  static getHostname() {
    const isLocal = process.env.MONGO_CONFIG === "LOCAL";
    const isUAT = process.env.MONGO_CONFIG === "UAT";

    const hostName = isLocal
      ? "http://localhost:3000/"
      : isUAT
      ? process.env.HOST_NAME_UAT
      : process.env.HOST_NAME_PROD;
    return hostName;
  }

  static async getcountries() {
    const payload = { data: "countires" }; // JSON object payload
    let data = await axios.post("/api/TravelServices/getData", payload);
    return data.data;
  }

  static async generateOnlineLeadForTravel(data) {
    const payload = { data: data }; // JSON object payload
    try {
      let response = await axios.post(
        "/api/TravelServices/createOnlineLeads",
        payload
      );
      if (response.data.acknowledged) {
        await localStorage.setItem("travelLeadID", response.data.insertedId);
      }
      return { status: true };
    } catch (err) {
      return { status: false };
    }
  }

  static async updateOnlineLeadForTravel(data) {
    const travelLeadID = await localStorage.getItem("travelLeadID");
    data.travelLeadID = travelLeadID;
    const payload = { data: data, case: "2" }; // JSON object payload
    try {
      let response = await axios.post(
        "/api/TravelServices/createOnlineLeads",
        payload
      );
      if (response.data.acknowledged) {
        //  await localStorage.setItem("travelLeadID",response.data.insertedId);
        //console.log("updateOnlineLeadForTravel", response.data)
      }
      return { status: true };
    } catch (err) {
      return { status: false };
    }
  }

  static async fetchTravelPlans() {
    const travelLeadID = await localStorage.getItem("travelLeadID");
    let payload = {
      travelLeadID: travelLeadID,
    };
    try {
      let response = await axios.post(
        "/api/TravelServices/fetchTravelPlans",
        payload
      );
      // console.log("fetchTravelPlans response: " + response.data)
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false };
    }
  }

  static async fetchredirectUrl(coverage, plan, withoutPED, selectedValues) {
    const travelLeadID = await localStorage.getItem("travelLeadID");
    let payload = {
      travelLeadID: travelLeadID,
      coverage: coverage,
      plan: plan,
      pedOpted: !withoutPED,
      selectedValues,
      case: 2,
    };
    try {
      let response = await axios.post(
        "/api/TravelServices/fetchTravelPlans",
        payload
      );
      // console.log("fetchTravelPlans response: " + response.data)
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false };
    }
  }
  static getZonesForTravel(selectedCountires, countryData) {
    let highestPriority = Infinity;
    // righ now height priority can be 3 but, if we later increase that so logic will still work fine
    let countryWithHighestPriority = null;

    selectedCountires.forEach((countryName) => {
      const country = countryData[countryName];
      if (country && parseInt(country.Priority) < highestPriority) {
        highestPriority = parseInt(country.Priority);
        countryWithHighestPriority = country;
      }
    });

    return countryWithHighestPriority;
  }

  static async generateOnlineLeadForTravelV2(data) {
    const payload = { data: data }; // JSON object payload
    try {
      let response = await axios.post(
        "/api/TravelServices/createOnlineLeadsV2",
        payload
      );
      if (response.data.acknowledged) {
        await localStorage.setItem("travelLeadID", response.data.insertedId);
      }
      return { status: true };
    } catch (err) {
      return { status: false };
    }
  }
  
  static async checkApplicationStatus(payload) {
    try {
      let response = await axios.post(
        "/api/telecallerInt/fetchStatus",
        payload
      );
      // console.log("fetchTravelPlans response: " + response.data.msg)
      return { status: true, data: response.data.msg };
    } catch (err) {
      // console.log("fetchTravelPlans response: " + err.message)
      return { status: false, data: err.message };
    }
  }

  static async getPinCodes() {
    try {
      let response = await axios.get(
        "/api/TravelServices/getAvailablePinCodes"
      );
      // console.log("fetchTravelPlans response: " + response.data.msg)
      return { status: true, data: response.data };
    } catch (err) {
      // console.log("fetchTravelPlans response: " + err.message)
      return { status: false, data: [] };
    }
  }

  static getDesieseIndexes(input) {
    let lastIdx = 0;
    let tracker = {};
    input.forEach((issue) => {
      let issueSplit = issue.split("_");
      let desieseName = issueSplit[2];
      if (!tracker[desieseName]) {
        tracker[desieseName] = lastIdx;
        lastIdx = lastIdx + 1;
      }
    });
    console.log("tracker", tracker);
    return tracker;
  }

  static returnMedicalFormJson(inputJSON) {
    //console.log("inputJSON", inputJSON);

    if (!inputJSON || Object.keys(inputJSON).length == 0) {
      return {};
    }

    const output = {};
    let issues = Object.keys(inputJSON);
    issues.forEach((elem) => {
      let issueObject = inputJSON[elem];
      //console.log("issueObject", issueObject);
      let issueObjectKey = Object.keys(issueObject);
      //console.log("issueObjectKey", issueObjectKey);

      let idxTracker = this.getDesieseIndexes(issueObjectKey);
      //console.log("idxTracker", idxTracker);
      issueObjectKey.forEach((key) => {
        let data = key.split("_");
        //console.log("Splitted data", data);
        let personType = data[0];
        let issueType = data[1];
        let dataKey = data[3];
        let desieseName = data[2];
        let dataIdx = idxTracker[desieseName] - 1;
        //console.log("dataKey", dataKey, personType, issueType, dataKey);

        if (!output[personType]) {
          output[personType] = {};
        }

        if (!output[personType][issueType]) {
          output[personType][issueType] = [];
        }

        if (output[personType][issueType][dataIdx]) {
          if (issueObject[key]) {
            output[personType][issueType][dataIdx][dataKey] = issueObject[key];
            output[personType][issueType][dataIdx]["dieseseName"] = data[2];
          }
        } else {
          // wll never called.
          output[personType][issueType][dataIdx] = {};
          if (issueObject[key]) {
            output[personType][issueType][dataIdx][dataKey] = issueObject[key];
            output[personType][issueType][dataIdx]["dieseseName"] = data[2];
          }
        }
      });
    });

    const opJson = JSON.stringify(output, null, 4);

    //console.log("Op json", opJson);
    return output;
  }

  static transformInputData(inputData) {
    console.log("inputData", inputData);
    let isWrongFormart = false;
    Object.keys(inputData).forEach((val) => {
      if (val.includes("question") && !isWrongFormart) {
        isWrongFormart = true;
      }
    });
    if (isWrongFormart) {
      inputData = this.returnMedicalFormJson(inputData);
    }
    let op = {
      question1: {},
      question2: {},
      question3: {},
      question4: {},
      question5: {},
      question6: {},
      question7: {},
      question8: {},
      question9: {},
      question10: {},
      question11: {},
      question12: {},
      question13: {},
      question14: {},
      question15: {},
      question16: {},
      question17: {},
      question18: {},
      question19: {},
      question20: {},
    };
    let peopleArray = Object.keys(inputData);
    //console.log(peopleArray)

    peopleArray.forEach((people) => {
      let peopleQuestionsObject = inputData[people];
      //console.log("peopleQuestionsObject", peopleQuestionsObject);

      let questionNumbers = Object.keys(peopleQuestionsObject);
      //console.log("questionNumbers",questionNumbers);
      questionNumbers.forEach((question) => {
        //console.log("questionNumbers", question);
        let insiderQuestion = peopleQuestionsObject[question];
        console.log("insiderQuestion", insiderQuestion);
        let localIdx = 0;
        insiderQuestion.forEach((details) => {
          if (details) {
            let desieseName = details.dieseseName;
            let detailKeys = Object.keys(details);
            // console.log("detailKeys", detailKeys);
            detailKeys.forEach((detail) => {
              op[question][`${people}_${question}_${desieseName}_${detail}`] =
                details[detail];
            });
            localIdx++;
          }
        });
        //op[question][`${people}_${question}_${localIdx}_`]=''
      });
    });

    for (const question in op) {
      if (Object.keys(op[question]).length === 0) {
        op[question] = "";
      }
    }
    console.log("op returned", op);
    return op;
  }

  static transormAspireSaverToHRMedQuestions(inputData, moreThan35) {
    inputData = JSON.parse(JSON.stringify(inputData)); // deep copy the object.
    let allPersons = Object.keys(inputData);
    let transFormedData = {};
    allPersons.forEach((people) => {
      transFormedData[people] = {};
    });
    //console.log("All person",allPersons,transFormedData)
    let addedQuestions = [];
    let questionMapper = !moreThan35
      ? {
          question2: "question3",
          question3: "question3",
          question4: "question4",
          question5: "question5",
          question6: "question6",
          question7: "question1",
          question8: "question2",
          question9: "question1",
        }
      : {
          question1: "question1",
          question2: "question2",
          question3: "question3",
          question4: "question3",
          question5: "question5",
          question6: "question6",
          question8: "question4",
        };
    allPersons.forEach((person) => {
      let questionObject = inputData[person]; // have objects of question1,question2 .......
      let questionLists = Object.keys(questionObject);
      questionLists.forEach((question) => {
        if (Object.keys(questionMapper).includes(question)) {
          // map to transform.
          // question2 will be changed to question3
          let newQuestionName = questionMapper[question];
          if (Object.keys(transFormedData[person]).includes(newQuestionName)) {
            // add in array
            inputData[person][question].forEach((val) => {
              //console.log("person",person,newQuestionName)
              //console.log("transFormedData[person][newQuestionName] = ",transFormedData[person][newQuestionName])
              transFormedData[person][newQuestionName].push(val);
            });
          } else {
            // create
            // console.log(
            //   "transFormedData",
            //   transFormedData,
            //   person,
            //   newQuestionName
            // );
            //transFormedData[person]={}
            transFormedData[person][newQuestionName] =
              inputData[person][question];
            addedQuestions.push(newQuestionName);
          }
        }
      });
    });
    return transFormedData;
  }

  static async createPaymentUrl(applicationId, amount, encryptedApplicationId) {
    let hostName = this.getHostname();
    const paymentLinkRequest = await fetch(`/api/CommonPaymentServiceNew`, {
      method: "POST",
      body: JSON.stringify({
        host: hostName,
        applicationId: applicationId,
        amount: amount,
        return_url: `payments/redirect-status`,
        encryptedApplicationId: encryptedApplicationId,
        productId: "travel_101",
        quoteId: applicationId,
        isComboCase: false,
        isPrepayment: true,
      }),
    });
    const paymentLinkResponse = await paymentLinkRequest.json();

    return { status: true, url: paymentLinkResponse };
  }

  static async createDialerLead(data) {
    let response = await axios.post(
      "/api/TravelServices/dialerLeadEntry",
      data
    );
    // console.log("fetchTravelPlans response: " + response.data.msg)
    return { status: true, data: response.data };
  }
}
